import {BorderArticle} from "@ui/general/BorderArticle";
import {PreviewCard} from "@ui/general/PreviewCard";
import {H3} from "@ui/titles/H3";

import styles from "./styles.module.scss";

export const SimulationsLayout = ({
  isBig = false,
  levelList,
  cards,
  title,
  background = "var(--white)",
  asButton = false,
}) => {
  return (
    <div className={"container-big phone:p-0"}>
      <div className={styles.simulationsWrapper}>
        <BorderArticle>
          <div
            className={styles.simulations}
            style={{background}}
          >
            <H3>{title}</H3>

            <ul className={styles.simulationsList}>
              {cards &&
                cards.map((item) => (
                  <li key={item?.id}>
                    <PreviewCard
                      asButton={asButton}
                      certified={item?.certified}
                      isBig={isBig}
                      due_date={item?.due_date}
                      finish_date={item?.finish_date}
                      start_date={item?.start_date}
                      levelList={levelList}
                      name={item?.name}
                      image={item?.cover}
                      until={item?.until}
                      mask={item?.mask}
                      id={item?.id}
                      mandatory={item?.mandatory}
                      // trainingLimit={item?.certification?.training_limit}
                    />
                  </li>
                ))}
            </ul>
          </div>
        </BorderArticle>
      </div>
    </div>
  );
};
